import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EmptyState } from "@/components/common";
import { fmtNum } from "@/lib/format";
import { Globe2, Landmark, Star, Bell } from "lucide-react";

// Watchlist-by-exchange dialog opened from the Markets tab.
export const ExchangeListingsDialog = ({ b }) => {
  const { exSel, setExSel, exListings, exLoading, watchSet, toggleWatch, quickAlert } = b;
  return (
    <Dialog open={!!exSel} onOpenChange={(o) => { if (!o) setExSel(null); }}>
      <DialogContent className="sm:max-w-lg" data-testid="broker-exchange-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Globe2 className="h-4 w-4" />{exSel?.name}</DialogTitle>
          <DialogDescription>
            {exSel?.currency} · {exSel?.instruments} listings · {exSel?.is_open ? "Open now" : "Closed"}. Tap the star to add a symbol to your watchlist.
          </DialogDescription>
        </DialogHeader>
        {exLoading ? (
          <EmptyState title="Loading listings…" />
        ) : exListings.length === 0 ? (
          <EmptyState title="No listings" />
        ) : (
          <div className="max-h-[60vh] overflow-auto space-y-1.5 pe-1" data-testid="broker-exchange-listings">
            {exListings.map((it) => (
              <div key={`${it.symbol}-${it.exchange || ""}`} className="flex items-center gap-2.5 rounded-lg border p-2.5" data-testid={`broker-listing-${it.symbol}`}>
                <button type="button" onClick={() => toggleWatch(it.symbol)}
                  className="text-muted-foreground hover:text-[color:var(--tharwy-lime-700)] transition-colors shrink-0"
                  title={watchSet.has(it.symbol) ? "Remove from watchlist" : "Add to watchlist"}
                  data-testid={`broker-star-${it.symbol}`}>
                  <Star className={`h-4 w-4 ${watchSet.has(it.symbol) ? "fill-[color:var(--tharwy-lime)] text-[color:var(--tharwy-lime-700)]" : ""}`} />
                </button>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium">{it.symbol.split(".")[0]}</div>
                  <div className="text-xs text-muted-foreground truncate">{it.name}</div>
                </div>
                <div className="text-end shrink-0">
                  <div className="numeric text-sm">{fmtNum(it.price)} {it.currency}</div>
                  <div className={`text-[11px] numeric ${it.change_pct >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                    {it.change_pct >= 0 ? "+" : ""}{it.change_pct}%
                  </div>
                </div>
                <button type="button" onClick={() => quickAlert(it.symbol)}
                  className="text-muted-foreground hover:text-[color:var(--tharwy-lime-700)] transition-colors shrink-0"
                  title="Create ±5% price alert" data-testid={`broker-alert-${it.symbol}`}>
                  <Bell className="h-4 w-4" />
                </button>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
